import { toJsonText } from "../../../features/builder.utils";
import { handlerOf, phaseText } from "./channel.utils";

const isEdit = (formData) => Boolean(formData?.id);

// EntityFormModal fields of a channel. Picking the channel fills the rest from its sender's defaults.
export const channelFields = [
  {
    name: "channel_key",
    label: "Channel",
    type: "select",
    is_api_data: true,
    optionsKey: "handlers",
    optionLabelFormatter: (handler) => `${handler.name} (${handler.id}) · ${phaseText(handler.phase)}${handler.channel_fid ? " · already set up" : ""}`,
    required: true,
    isReadOnly: isEdit,
    onValueChange: (value, formData, dependencies) => {
      const handler = handlerOf({ channel_key: value }, dependencies);
      if (!handler) return {};
      return {
        name: formData.name || handler.name,
        description: formData.description || handler.description || "",
        icon: formData.icon || handler.icon || "",
        supports_digest: handler.supports_digest === true,
        supports_html: handler.supports_html === true,
        template_schema_text: toJsonText(handler.template_schema),
        config_schema_text: toJsonText(handler.config_schema),
      };
    },
  },
  { name: "name", label: "Name", required: true, maxLength: 100 },
  { name: "icon", label: "Icon", maxLength: 50, hint: "A lucide icon name shown next to the channel, e.g. Mail." },
  { name: "rate_limit_per_min", label: "Rate limit (per minute)", type: "number", min: 1, max: 100000, hint: "Leave empty for no limit." },
  { name: "sort_order", label: "Sort order", type: "number", min: 0, max: 10000 },
  {
    name: "supports_digest",
    label: "Digest",
    type: "boolean",
    isReadOnly: (formData, dependencies) => handlerOf(formData, dependencies)?.supports_digest !== true,
    hint: (formData, dependencies) => (handlerOf(formData, dependencies) && handlerOf(formData, dependencies).supports_digest !== true ? "Not supported by this channel." : "Combine several reminders into one message."),
  },
  {
    name: "supports_html",
    label: "HTML content",
    type: "boolean",
    isReadOnly: (formData, dependencies) => handlerOf(formData, dependencies)?.supports_html !== true,
    hint: (formData, dependencies) => (handlerOf(formData, dependencies) && handlerOf(formData, dependencies).supports_html !== true ? "Not supported by this channel." : "Templates may use rich HTML."),
  },
  { name: "is_activated", label: "Active", type: "boolean", defaultValue: true, editValue: (record) => record.is_activated === true },
  { name: "description", label: "Description", type: "textarea", fullWidth: true, rows: 2, maxLength: 500 },
  {
    name: "edit_schemas",
    label: "Edit schemas as JSON",
    type: "boolean",
    editValue: () => false,
    hint: "Off keeps the sender's defaults on a new channel, and the saved schemas on an edit.",
  },
  {
    name: "template_schema_text",
    label: "Template schema",
    type: "textarea",
    fullWidth: true,
    rows: 8,
    hidden: (formData) => !formData.edit_schemas,
    editValue: (record) => toJsonText(record.template_schema),
  },
  {
    name: "config_schema_text",
    label: "Config schema",
    type: "textarea",
    fullWidth: true,
    rows: 5,
    hidden: (formData) => !formData.edit_schemas,
    editValue: (record) => toJsonText(record.config_schema),
  },
];
